import dayjs from "dayjs";
import AuthService from "../api/AuthService";

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
const STORAGE_KEY = "dateFormat";

let currentFormat = localStorage.getItem(STORAGE_KEY) || DEFAULT_DATE_FORMAT;
let fetchPromise = null;

export function getDateFormat() {
  return currentFormat;
}

export function setDateFormat(format) {
  currentFormat = format && typeof format === "string" ? format : DEFAULT_DATE_FORMAT;
  try {
    localStorage.setItem(STORAGE_KEY, currentFormat);
  } catch (error) {
    // localStorage unavailable (private mode, etc.) - keep in-memory value only
  }
}

// Fetches the company's configured date format once and caches it. Safe to call
// from multiple places on app/page load - concurrent calls share the same request.
export function refreshDateFormat(companyToken) {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    return Promise.resolve(currentFormat);
  }
  if (fetchPromise) {
    return fetchPromise;
  }
  fetchPromise = AuthService.getCompanySettings(companyToken)
    .then((result) => {
      if (result?.success && result?.data?.dateFormat) {
        setDateFormat(result.data.dateFormat);
      }
      return currentFormat;
    })
    .catch(() => currentFormat)
    .finally(() => {
      fetchPromise = null;
    });
  return fetchPromise;
}

export function formatWithConfiguredDate(value, fallback = "-") {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  const parsed = dayjs(value);
  if (!parsed.isValid()) {
    return fallback;
  }
  return parsed.format(currentFormat);
}
